import { useSelector } from 'react-redux';
import { selectReviewById } from './reviewsSlice';
import { PoiRating } from '../pois/PoiList';
import { Link, useHistory } from 'react-router-dom';
import '../../stylesheets/Review.css';
import { FormatDate } from '../../lib/date-helper';
import { selectAllStrings } from '../language/languageSlice';
import { selectDeviceIds } from '../user/userSlice';

const Review = ({reviewId, selector, showLink, showDate, showControls = false, 
    onEdit=f=>f, onDelete=f=>f, forceShowControls = false}) => {
    const review = useSelector((state) => selector(state, reviewId));
    const strings = useSelector(selectAllStrings);
    const history = useHistory();
    const deviceIds = useSelector(selectDeviceIds);

    return <div className="review">
        <div className="left-header">
            <div className="image">
                <img alt="author" src={review.photo || '/images/user_placeholder.png'}/>
            </div>
            <div className="name">{review.name || review.nominativo || review.pr_user_firstname}</div>
            <div className="poi-name" onClick={() => history.push(`/pois/${review.poi_id}`)}>{review.poi_name}</div>
            <PoiRating rating={review.eval ? review.eval : review.re_valore}/>
        </div>
    
        {showDate ? <div className="date"><FormatDate date={review.date}/></div> : null}
        {showLink  ? <Link className="see-poi" to={`/pois/${review.poi_id}`}>{strings.see_poi}</Link> : null}
        <div className="text">{review.review ? review.review : review.re_testo}</div>
        {forceShowControls || (showControls && deviceIds.includes(review.pr_id)) ? <div className="controls">
        <a href="#" onClick={event => onEdit(event, review)}>{strings.edit}</a> | <a href="#" 
        onClick={event => onDelete(event, review.re_id)}>{strings.delete}</a>
        </div> : null}
    </div>
};

export default Review;